import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Grid, LinearProgress, Typography } from '@mui/material';
import $ from "jquery";
import Common from '../utilities/common';
import { NormalizationProgressItem } from '../models/NormalizationItem';

export interface INormalizeProgressItemProps {
    item: NormalizationProgressItem;
}

export interface INormalizeProgressItemState {
    data: any;
}

export default class NormalizeProgressItem extends React.Component<INormalizeProgressItemProps, INormalizeProgressItemState> {
    public constructor(props: INormalizeProgressItemProps) {
        super(props);

        this.state = {
            data: {}
        }
    }

    componentDidMount(): void {
        this.GetData();
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                <Box style={{marginTop: '40px'}}>
                    <Grid container spacing={2} className='normalizeItem'>
                        <Grid item xs={8} style={{backgroundColor: '#f4f4f4'}}>
                            <Typography variant='body2' fontWeight={600}>
                                {
                                    this.props.item.Path.split('\\')[this.props.item.Path.split('\\').length - 1]
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={3} style={{backgroundColor: '#f4f4f4', textAlign: 'right'}}>
                            <Typography variant='body2' fontWeight={600}>
                                {
                                    `Normalizar: ${this.props.item.Actions}`
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={1} style={{backgroundColor: '#f4f4f4', textAlign: 'right'}}>
                            <Button variant="text" style={{position: 'relative', top: '-6px'}} onClick={() => {
                                window.location.href = `/normalizacion?n=${this.props.item.ID}`
                            }}>
                                Detalle
                            </Button>
                        </Grid>
                        {
                            this.state.data.Status == 'Activo' && (
                                <Grid item xs={12} style={{padding: '20px 10px'}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" value={this.state.data.Progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.data.Progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            )
                        }
                    </Grid>
                </Box>
            </div>
        )
    }

    private GetData(): void {
        let url = `${Common.END_POINT}/normalizations/items/${this.props.item.ID}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: NormalizationProgressItem[]) => {
            this.setState(
                {
                    data: response[0]
                }
            );
        });
    }
}